import { render, staticRenderFns } from "./DeleteDialog.vue?vue&type=template&id=0b0e0ac8&"
import script from "./DeleteDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b0e0ac8')) {
      api.createRecord('0b0e0ac8', component.options)
    } else {
      api.reload('0b0e0ac8', component.options)
    }
    module.hot.accept("./DeleteDialog.vue?vue&type=template&id=0b0e0ac8&", function () {
      api.rerender('0b0e0ac8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/stream/DeleteDialog.vue"
export default component.exports